<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Vistoria_1920x324-2.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">Vistoria Cautelar</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="content">
        <div class="left">
          <div class="ckeditor">
            <p>Os dados mais assertivos para o seu negócio de forma personalizável. Selecione as informações de acordo
              com as necessidades específicas da sua empresa para tomar a melhor decisão.</p>
            <p>O que é a Vistoria Cautelar?</p>
            <p>Uma solução que fornece todos os dados relativos para a decisão de compra de um veículo. Através da
              Vistoria, você tem acesso às mais importantes informações de:</p>
          </div>
          <div class="button">
            <a class="btn gradient" href="/vistoria-cautelar/">Exemplo de Vistoria</a>
          </div>
        </div>
      </div>

    </div>
  </section>

  <section class="wrap-vcl">
    <div class="layout">
      <div class="box">
        <div class="vcl-media">
          <div class="institucional__video">
            <video #institucionalVideo class="institucional__player" controls preload="metadata" playsinline muted
              aria-label="Vídeo institucional da Carcheck Brasil">
              <source
                src="https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/VIDEO_VISTORIA_CAUTELAR.mp4"
                type="video/mp4" />
              Seu navegador não suporta reprodução de vídeo.
            </video>
          </div>
        </div>
        <div class="content">
          <div class="list-topics">
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/vistoria@2x.png"
                  alt="Estrutura do veículo" loading="lazy">
              </div>
              <div class="text">
                <p>Estrutura do veículo;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/vistoria@2x.png"
                  alt="Colisões graves" loading="lazy">
              </div>
              <div class="text">
                <p>Colisões graves com danos (como colunas e longarinas);</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/vistoria@2x.png"
                  alt="Reparos de pintura" loading="lazy">
              </div>
              <div class="text">
                <p>Reparos de pintura ou uso de massa plástica;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/vistoria@2x.png"
                  alt="Histórico veicular" loading="lazy">
              </div>
              <div class="text">
                <p>Histórico Veicular com dados de sinistros, restrições, leilões ou qualquer informação que possa
                  interferir na negociação do seminovo;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-contact-box></app-contact-box>

</main>